import { DropdownOption } from "core/models";

export const subtitleExportOptionsBasic: DropdownOption[] = [
    {
        id: "nothing",
        value: undefined,
        title: `Don't use`,
    },
    {
        id: "burn",
        value: "burn",
        title: "Burn into video",
    },
];

const subtitleExportOptions: DropdownOption[] = [
    ...subtitleExportOptionsBasic,
    {
        id: "export",
        value: "export",
        title: "Export with video",
    },
];

export default subtitleExportOptions;
